import { useState } from "react";
import { Link } from "react-router-dom";
import type { Work, WorkType } from "@/types/media";
import WorkCard from "@/components/base/WorkCard";

interface FeaturedTabsProps {
  works: Work[];
}

const TABS: { key: WorkType; label: string; icon: string }[] = [
  { key: "movie", label: "电影", icon: "ri-film-line" },
  { key: "tv", label: "电视剧", icon: "ri-tv-2-line" },
  { key: "variety", label: "综艺", icon: "ri-mic-line" },
];

export default function FeaturedTabs({ works }: FeaturedTabsProps) {
  const [active, setActive] = useState<WorkType>("movie");

  const list = works
    .filter((w) => w.type === active)
    .sort((a, b) => b.popularity - a.popularity)
    .slice(0, 6);

  return (
    <section className="mx-auto w-full px-4 py-10 md:px-6 md:py-12">
      <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div className="flex items-center gap-3">
          <span className="h-6 w-1.5 rounded-full bg-accent-500"></span>
          <div>
            <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
              热门影视精选
            </h2>
            <p className="mt-1 text-sm text-foreground-500">
              精选各类型高热与口碑作品，快速发现你的下一部片单
            </p>
          </div>
        </div>

        <div className="inline-flex rounded-full border border-background-300 bg-background-100 p-1">
          {TABS.map((tab) => (
            <button
              key={tab.key}
              type="button"
              onClick={() => setActive(tab.key)}
              className={`flex items-center gap-1 rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
                active === tab.key
                  ? "bg-primary-600 text-background-50"
                  : "text-foreground-700 hover:text-primary-700"
              }`}
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className={`${tab.icon} text-base`}></i>
              </span>
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
        {list.map((work) => (
          <WorkCard key={work.id} work={work} />
        ))}
      </div>

      <div className="mt-6 flex justify-center">
        <Link
          to={`/category/${active}`}
          className="inline-flex items-center gap-1 rounded-md border border-primary-300 bg-primary-50 px-5 py-2.5 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-100"
        >
          浏览更多{TABS.find((t) => t.key === active)?.label}
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-arrow-right-line text-base"></i>
          </span>
        </Link>
      </div>
    </section>
  );
}